import { useEffect, useRef, useState } from "react";
import Footer from "../../components/footer";
import Menu from "../../components/menu";
import useAuth from "../../hooks/useAuth";
import { toast, ToastContainer } from "react-toastify";

import styles from './styles.module.css'

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { authApi } from "../../services/api/api";
import MiniPerfil from "../../components/miniPerfil";
import MiniPerfilSkeleton from "../../components/skeletons/miniUser";
import { Camera } from "lucide-react";


export default function Profile() {

    const api = authApi()

    const { user, theme, setUser } = useAuth()

    const [file, setfile] = useState('')

    const [image, setImage] = useState(user?.img ?? '')

    const [name, setName] = useState(user?.name ?? '')

    const [email, setEmail] = useState(user?.email ?? '')

    let inputRef = useRef<HTMLInputElement>(null)

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [users, setUsers] = useState(null);

    async function getUsers() {
        const data = await api.selectUser()
        setUsers(data)
    }

    useEffect(() => {
        getUsers()
    }, [])

    function handleImg() {
        if (inputRef) {
            inputRef.current?.click()
        }
    }

    function handleFile(e: React.ChangeEvent<HTMLInputElement>) {
        const selectedFiles = e.target.files as FileList


        if (selectedFiles.length == 0) return

        if (selectedFiles?.[0].size > 1048576) {
            toast.error('A imagem não pode ultrapassar 1mb.', { theme: 'dark', toastId: 'password' })
            return
        }

        setfile(URL.createObjectURL(selectedFiles?.[0]))

        if (e.target.files) {

            const files = e.target.files[0]

            const reader = new FileReader()
            reader.readAsBinaryString(e.target.files[0])
            reader.onload = (ev: any) => {
                setImage(`data:${files.type};base64,${btoa(ev.target.result)}`)
            }
        }
    }

    async function handleUpdate() {

        toast.loading('Atualizando...', { theme: 'dark', toastId: 'attUser' })

        const dados = {
            id: user.id,
            name: name,
            email: email,
            img: image
        }

        const data = await api.updatePerfil(dados)

        if (data != 500) {
            handleClose()
            toast.dismiss('attUser')
            setName(data.name)
            setEmail(data.email)
            setImage(data.img)
            setUser(data)
            toast.success('Dados atualizados com sucesso', { theme: 'dark', toastId: 'attDados' })
            getUsers()
        } else {
            handleClose()
            toast.dismiss('attUser')
            toast.error('Erro ao atualizar tente novamente mais tarde', { theme: 'dark', toastId: 'erroAttDados' })
        }
    }

    async function handleUpdatePass() {

        toast.loading('Carregando...', { theme: 'dark', toastId: 'attPass' })

        const data = await api.resetPassword(user.email)

        if (data == 'passwords.sent') {
            toast.dismiss('attPass')
            handleClose1()
            toast.info('Acesse seu e-mail para trocar a senha', { theme: 'dark', toastId: 'att' })
        } else if (data == 'passwords.throttled') {
            handleClose1()
            toast.info('Acesse seu e-mail para trocar a senha', { theme: 'dark', toastId: 'att' })
        }

    }


    return (
        <div className={` w-screen bg-gray-100 ${theme} overflow-x-hidden`}>
            <Menu />
            <div className="content w-screen min-h-screen flex justify-center bg-gray-50 dark:bg-[#061c3f] transition-colors duration-500">
                <div className="lg:max-w-[1850px] md:max-w-2xl w-full px-4 py-8 md:py-12">

                    {/* Header Padronizado */}
                    <div className="w-full mb-8">
                        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
                            <div className="flex flex-col gap-1">
                                <h4 className="text-slate-400 dark:text-blue-300/50 text-[10px] font-bold uppercase tracking-[0.3em]">
                                    Configurações
                                </h4>
                                <h2 className="text-2xl font-bold text-slate-800 dark:text-white tracking-tight">
                                    Seu Perfil
                                </h2>
                            </div>


                        </div>
                        <div className="w-full h-[1px] bg-gray-200 dark:bg-white/10 mt-4"></div>
                    </div>

                    {/* Grid Principal */}
                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">

                        {/* Card da Esquerda: Foto e Ações Rápidas */}
                        <div className="lg:col-span-1">
                            <div className="bg-white dark:bg-[#0a2652] rounded-[2rem] p-8 border border-gray-100 dark:border-white/10 shadow-sm flex flex-col items-center">
                                <div className="relative group">
                                    <div className="absolute inset-0 bg-blue-500 rounded-full blur opacity-20 group-hover:opacity-40 transition-opacity"></div>
                                    <img
                                        src={image}
                                        alt="foto do usuario"
                                        className="w-40 h-40 rounded-full object-cover border-4 border-white dark:border-[#0d2d5f] shadow-xl relative z-10"
                                    />
                                    <button
                                        onClick={handleImg}
                                        className="absolute bottom-0 right-0 p-3 bg-blue3 text-white rounded-full shadow-lg hover:bg-blue-700 transition-all z-20 active:scale-90"
                                    >
                                        <Camera size={20} />
                                    </button>
                                </div>
                                <input name="image" type="file" accept="image/*" className="hidden" ref={inputRef} onChange={(e) => handleFile(e)} />

                                <h3 className="mt-6 text-lg font-bold text-slate-800 dark:text-white">{name}</h3>
                                <p className="text-sm text-slate-400 dark:text-blue-300/60 mb-6">{email}</p>

                                <div className="flex flex-col space-y-2 w-full">
                                    <button
                                        onClick={handleClickOpen1}
                                        className="w-full py-3 px-4 text-[11px] font-bold uppercase tracking-widest text-blue-600 dark:text-blue-400 border border-blue-100 dark:border-blue-500/20 rounded-xl hover:bg-blue-50 dark:hover:bg-blue-500/10 transition-all"
                                    >
                                        Alterar Senha
                                    </button>
                                    <button
                                        onClick={handleClickOpen}
                                        className="w-full py-3 px-4 text-[11px] font-bold uppercase tracking-widest bg-blue3 hover:bg-blue-700 text-white shadow shadow-blue-500/20 dark:border-blue-500/20 rounded-xl  dark:hover:bg-blue-500/10 transition-all"
                                    >
                                        Salvar Alterações
                                    </button>
                                </div>
                                {/* <button
                                    onClick={handleClickOpen}
                                    className="flex items-center justify-center gap-2 px-6 h-11 bg-blue3 hover:bg-blue-700 text-white rounded-xl shadow shadow-blue-500/20 transition-all active:scale-95"
                                >
                                    <span className="text-xs font-bold uppercase tracking-widest">Salvar Alterações</span>

                                </button> */}
                            </div>
                        </div>

                        {/* Card da Direita: Formulário de Dados */}
                        <div className="lg:col-span-2 space-y-8">
                            <div className="bg-white dark:bg-[#0a2652] rounded-[2rem] p-8 border border-gray-100 dark:border-white/10 shadow-sm">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                    <div className="flex flex-col gap-2">
                                        <label className="text-[10px] uppercase font-bold tracking-widest text-slate-400 dark:text-blue-300/50 ml-1">
                                            Nome Completo
                                        </label>
                                        <input
                                            className="w-full p-3 rounded-xl bg-gray-50 dark:bg-[#061c3f]/50 border border-gray-100 dark:border-white/5 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                                            value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>
                                    <div className="flex flex-col gap-2">
                                        <label className="text-[10px] uppercase font-bold tracking-widest text-slate-400 dark:text-blue-300/50 ml-1">
                                            E-mail Institucional
                                        </label>
                                        <input
                                            className="w-full p-3 rounded-xl bg-gray-50 dark:bg-[#061c3f]/50 border border-gray-100 dark:border-white/5 dark:text-white focus:ring-2 focus:ring-blue-500 outline-none transition-all"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Seção de Membros */}
                            <div className="pt-4">
                                <div className="flex items-center gap-4 mb-6">
                                    <h2 className="text-xl font-bold text-slate-800 dark:text-white tracking-tight">Membros da Comunidade</h2>
                                    <div className="flex-1 h-[1px] bg-gray-200 dark:bg-white/10"></div>
                                </div>

                                <div className="grid grid-cols-4 sm:grid-cols-3 md:grid-cols-6 lg:grid-cols-6 xl:grid-cols-8 2xl:grid-cols-12 gap-4 p-2">
                                    {users ? users.map((user) => (
                                        <div key={user.id} className="hover:scale-105 transition-transform">
                                            <MiniPerfil user={user} />
                                        </div>
                                    )) : <MiniPerfilSkeleton />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Atualizar dados."}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h1>Tem certeza que deseja atualizar os dados?</h1>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUpdate} autoFocus>
                        Atualizar
                    </Button>
                    <Button onClick={handleClose} color="error" autoFocus>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={open1}
                onClose={handleClose1}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Atualizar dados."}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <h1>Tem certeza que deseja alterar a senha?</h1>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUpdatePass} autoFocus>
                        Trocar senha
                    </Button>
                    <Button onClick={handleClose1} color="error" autoFocus>
                        Cancelar
                    </Button>
                </DialogActions>
            </Dialog>

            <ToastContainer />
            {/* <Footer/> */}
            <div className="w-full h-8 dark:bg-slate-800"></div>
        </div>
    )
}